import { lazy, Suspense, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const HARNESS_ENABLED =
  import.meta.env.DEV && import.meta.env.VITE_DEV_HARNESS_ENABLED === 'true';

/**
 * F5: Route-level guard. If the triple-gate fails we redirect.
 * The harness module is only imported when the guard succeeds AND the env
 * flag is statically true at build time, so Vite tree-shakes it out of
 * production bundles.
 */
export function DevHarnessGuard({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return null;
  if (!HARNESS_ENABLED || !user) {
    return <Navigate to="/app/talk" replace />;
  }
  return <Suspense fallback={null}>{children}</Suspense>;
}

// Lazy import only when the harness is enabled at build time.
// In production builds (DEV=false), the dynamic import below is dead code and
// `TalkDebug` is excluded from the bundle.
export const TalkDebugLazy = HARNESS_ENABLED
  ? lazy(() => import('@/pages/app/TalkDebug'))
  : () => null;
